/**
 * styles.ts
 *
 * Author: Maurice T. Meyer
 * E-Mail: maurice@lavireo.com
 *
 * (c) Laviréo. All rights reserved.
 *
 * This document is the property of Laviréo.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Laviréo.
 */

import { css } from '@emotion/react';

export const styles = {
  container: css({
    position: 'relative',
  }),

  options: css({
    position: 'absolute',
    top: '100%',
    left: 0,
    width: '100%',
    maxHeight: '200px',
    overflowY: 'auto',
    backgroundColor: '#fff',
    border: '1px solid #000',
    borderRadius: '5px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
    zIndex: 100,
  }),
  option: css({
    padding: '8px 12px',
    cursor: 'pointer',
    borderBottom: '1px solid #000',
    textAlign: 'left',
    textDecoration: 'none',
    
    ':last-child': {
      borderBottom: 'none',
    },

    ':hover': {
      backgroundColor: '#f0f0f0',
    }
  }),
}